import { getTmsInstance } from "integration-web-core--socle/js/assets/commons/_tms";
export function pushTmsEvent(target, eventName, eventData) {
  getTmsInstance().pushEvent(target, "cdl_event", {
    event_name: eventName,
    event_data: eventData
  });
}